import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ShopSettingsService } from '../../general/services/shop-settings.service';
import { PartnerStateService } from '../../partner/services/partner-state.service';

@Injectable()
export class BookingsGuard implements CanActivate {

  constructor(
    private partnerStateService: PartnerStateService,
    private router: Router,
    private shopSettingsService: ShopSettingsService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (
      !this.shopSettingsService.isVUMode
      && this.shopSettingsService.shopSettings.authorizationRequired
      && !this.partnerStateService.loggedInPartner
    ) {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}
